import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system";
import { tabsAnatomy as parts } from "@chakra-ui/anatomy";

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);

const baseStyle = definePartsStyle({
  tab: {
    fontWeight: "semibold", // change the font weight
  },
});

const variants = {
  custombackground: definePartsStyle({
    tab: {
      color: "grayish_tabs",
      _selected: {
        color: "red_origin",
        borderColor: "red_origin",
        borderBottomWidth: "3px",
        borderStyle: "solid",
      },
    },
  }),
};

const Tab = defineMultiStyleConfig({
  baseStyle,

  variants,
  defaultProps: { size: "", variant: "custombackground" },
});
export default Tab;
